var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"slider-campanha"}},[_c('div',{staticClass:"slider-produtos-home"},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.slideSettings,false),_vm._l((_vm.produtos),function(item,index){return _c('ItemProduto',{key:index,attrs:{"item":item,"use-default-view-type":true,"visualizacao":"lista-1"}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }